import commonTranslations from 'app/locales/locale-ru';

const localeTexts = {
    ...commonTranslations,

    detailsTableTitle: 'Что в наборе?',

    msk: 'Москва',
    mskOutside: 'За МКАД',
    spb: 'Санкт-Петербург',
    spbOutside: 'За КАД',

    dessert: 'Десерты',
    set: 'Наборы',
    main: 'Главные блюда',
    appetizer: 'Салаты и закуски',
    niceStuff: 'Приятные мелочи',

    detailsWeightTitle: 'Сколько получится?',
    detailsCookTitle: 'Сколько готовить?',

    orderTitle: 'Оформить заказ',
    orderOfferText: 'Нажимая «Оформить заказ», Вы принимаете условия',
    orderOfferLink: 'Пользовательского соглашения',

    addressPlaceholder: 'Улица, номер дома',
    flatPlaceholder: 'Квартира',
    entrancePlaceholder: 'Подъезд',
    checkoutButton: 'Оплатить',

    checkoutDeliveryDateTitle: 'Дата доставки',
    checkoutDeliveryTimeTitle: 'Время доставки',
    checkoutDeliveryDateDelimiter: 'С этой даты - другое меню!',
    checkoutDeliveryDateInfoTimeChaned: 'Обратите внимание! Изменилось время доставки.',
    checkoutDeliveryDateInfoDisabled: 'Чтобы мы смогли предложить вам корректные дату и время доставки, введите адрес в поле выше',
    checkoutDeliveryDateInfoDeliveryZone: 'В выходные доступны другие временные интервалы.',
    checkoutDeliveryDateInfoSelectInterval: 'Выберите доступный интервал доставки',
    checkoutDeliveryDateInfoIntervalChanged: 'Обратите внимание: время доставки за МКАД изменилось',
    checkoutDeliveryTimeInfoOneInterval: 'Доступен только один интервал доставки',

    checkoutErrorEmptyPhone: 'Введите номер телефона',
    checkoutErrorDeliveryZone: 'Извините, доставка доступна только по Москве и 60 км от МКАД',
    checkoutErrorEmptyAddress: 'Введите адрес',
    checkoutErrorWrongAddress: 'Некорректный адрес',
    checkoutErrorEmptyHouse: 'Не введен номер дома',

    basketTitle: 'В Вашем заказе:',
    basketButtonTitle: 'В вашей корзине:',
};

export default localeTexts;
